import { useFormContext } from 'react-hook-form';
import { CatalogProductFormState } from './catalogFormValues';
import { catalogPropertyGroups } from './catalogPropertyFields';
import { CatalogFormSection } from './CatalogFormSection';
import { ProductPropertyField } from './ProductPropertyField';

export function ProductPropertiesSection() {
  const { formState } = useFormContext<CatalogProductFormState>();
  const error = formState.errors.product_properties?.message;
  return <div className="catalog-properties">{error ? <p className="catalog-feedback catalog-feedback_error" role="alert">{String(error)}</p> : null}{catalogPropertyGroups.map((group, index) => <CatalogFormSection key={group.title} id={`properties-${index}`} title={group.title} description="Заполняйте только известные сведения о товаре.">{group.fields.map((descriptor) => <ProductPropertyField key={descriptor.path} descriptor={descriptor} />)}</CatalogFormSection>)}</div>;
}
